import { c as _c } from "react-compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { getFrameworkAppSettings } from '../fasApi';
import { COLLABORATION_SIDEBAR_FAS_NAMESPACE, COMMENTING_FAS_NAMESPACE } from '../constants';
import { LEGACY_COMMENT_OBJECT_TYPES } from '../../../constants/CommentObjectType';
export default function useFrameworkAppSettings() {
  "use memo";

  const $ = _c(10);
  const [loading, setIsLoading] = useState(true);
  const [appSettings, setAppSettings] = useState(null);
  let t0;
  if ($[0] !== appSettings) {
    t0 = appName => {
      var _appSettings$appName;
      return (appSettings === null || appSettings === void 0 || (_appSettings$appName = appSettings[appName]) === null || _appSettings$appName === void 0 || (_appSettings$appName = _appSettings$appName[COLLABORATION_SIDEBAR_FAS_NAMESPACE]) === null || _appSettings$appName === void 0 ? void 0 : _appSettings$appName.metadata) || null;
    };
    $[0] = appSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getCollaborationSidebarAppSetting = t0;
  let t1;
  if ($[2] !== appSettings) {
    t1 = objectTypeId => {
      var _appSettings$objectTy;
      if (LEGACY_COMMENT_OBJECT_TYPES.includes(objectTypeId)) {
        return {
          enabled: {
            value: true
          }
        };
      }
      return (appSettings === null || appSettings === void 0 || (_appSettings$objectTy = appSettings[objectTypeId]) === null || _appSettings$objectTy === void 0 || (_appSettings$objectTy = _appSettings$objectTy[COMMENTING_FAS_NAMESPACE]) === null || _appSettings$objectTy === void 0 ? void 0 : _appSettings$objectTy.metadata) || null;
    };
    $[2] = appSettings;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getCommentingAppSetting = t1;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsLoading(true);
      getFrameworkAppSettings().then(response => {
        setAppSettings(response);
        setIsLoading(false);
      }).catch(() => {
        setIsLoading(false);
      });
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== getCollaborationSidebarAppSetting || $[7] !== getCommentingAppSetting || $[8] !== loading) {
    t4 = {
      getCollaborationSidebarAppSetting,
      getCommentingAppSetting,
      loading
    };
    $[6] = getCollaborationSidebarAppSetting;
    $[7] = getCommentingAppSetting;
    $[8] = loading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}